<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div
        class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <div>
                <img *ngIf="style.logoUrl" [src]="style.logoUrl" alt="Logo" class="sidebar-logo rounded-2xl">
            </div>


            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">
                <div class="loading-message">
                    <p>Opening app...</p>
                  </div>
            </div>

        </div>
    </div>
    <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-28 overflow-hidden " [ngStyle]="{'background-color': style.backgroundColor, 'color': style.textColor}">
        <!-- <div [innerHTML]="introductionHtml"></div> -->
    </div>
</div>
<div style="display: flex; justify-content: flex-end; padding: 1rem; background-color: var(--background-color)">
    <languages></languages>
</div>
